import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
// custom validators
import { AxisAlphabetsValidatorDirective } from './axis-alphabets.validator';
import { AxisAlphaNumericsValidatorDirective } from './axis-alphaNumeric.validator';
import { AxisCurrencyValidatorDirective } from './axis-currency.validator';
import { AxisDecimalValidatorDirective } from './axis-decimal.validator';
import { AxisEmailValidatorDirective } from './axis-email.validator';
import { AxisNumericsValidatorDirective } from './axis-numerics.validator';
import { AxisRangeValidatorDirective } from './axis-range.validator';

@NgModule({
  imports: [FormsModule],
  declarations: [
    AxisAlphabetsValidatorDirective,
    AxisNumericsValidatorDirective,
    AxisCurrencyValidatorDirective,
    AxisEmailValidatorDirective,
    AxisAlphaNumericsValidatorDirective,
    AxisDecimalValidatorDirective,
    AxisRangeValidatorDirective
  ],
  exports: [
    AxisAlphabetsValidatorDirective,
    AxisNumericsValidatorDirective,
    AxisCurrencyValidatorDirective,
    AxisEmailValidatorDirective,
    AxisAlphaNumericsValidatorDirective,
    AxisDecimalValidatorDirective,
    AxisRangeValidatorDirective
  ]
})
export class AxisValidatorModule {}
